import './DefaultPaymentMethod.scss';

import classNames from 'classnames';

import Icon from 'atoms/icon';
import { getCardIcon, isEmpty, isNotEmptyArray } from 'util';

export function DefaultPaymentMethod({ cards, savedCardLabel }) {
  const lastCard = cards?.[0] || {};

  if (!isNotEmptyArray(cards) || isEmpty(lastCard))
    return <p className="f13">No card available.</p>;

  return (
    <div className="flex-column default-payment-method">
      {savedCardLabel && (
        <div className="flex-row mb-10">
          <div className="radius-50 radio-btn radius-100 flex-row justify-center">
            <span className="radius-100 b-primary-orange" />
          </div>
          <p className="f13 bold">Saved card</p>
        </div>
      )}
      <div className="flex-row">
        <Icon name={getCardIcon(lastCard?.brand)} />
        <div className="flex-column">
          <p className="f13">{`**** **** **** ${lastCard?.last4}`}</p>
          <p className="grey-text f11">{`Expires ${lastCard?.expiration?.month}/${lastCard?.expiration?.year}`}</p>
        </div>
      </div>
    </div>
  );
}
